// extracted by mini-css-extract-plugin
export default {"label":"Search_label__D9SXB","input":"Search_input__b8jmh"};